import React, { useState, useRef } from "react";
import {
    Box,
    Typography,
    CircularProgress,
    useMediaQuery
} from "@mui/material";

const messages = [
    "Calculating optimized times",
    "Finding most efficient routes",
    "Finalizing route",
    "Almost there"
];

const CustomAnimatedSpinner = ({ loading }) => {
    const intervalRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [dotCount, setDotCount] = useState(0);

    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

    // Start the interval when loading starts
    if (loading && !intervalRef.current) {
        intervalRef.current = setInterval(() => {
            setDotCount((prevDotCount) => {
                if (currentIndex === messages.length - 1) {
                    // If on the last message
                    if (prevDotCount < 3) {
                        return prevDotCount + 1; // Increment dots
                    } else {
                        return 3; // Keep at 3 dots
                    }
                } else {
                    // If not on the last message
                    if (prevDotCount < 3) {
                        return prevDotCount + 1; // Increment dots
                    } else {
                        // Reset dots and move to the next message
                        setCurrentIndex((prevIndex) => {
                            // Move to next message if not at the last one
                            return prevIndex < messages.length - 1
                                ? prevIndex + 1
                                : prevIndex;
                        });
                        return 0; // Reset dot count
                    }
                }
            });
        }, 500);
    }

    // Clear the interval if not loading
    if (!loading && intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setCurrentIndex(0);
        setDotCount(0);
    }

    // Determine the current message
    const currentMessage = messages[currentIndex];
    const animatedDots = ".".repeat(dotCount);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: isMobile ? 100 : 283
            }}
        >
            <CircularProgress size={36} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "18px",
                    position: "relative"
                }}
            >
                <Typography
                    sx={{
                        textAlign: "center",
                        flexShrink: 0,
                        whiteSpace: "nowrap"
                    }}
                >
                    {currentMessage}
                </Typography>
                <Typography
                    sx={{
                        position: "absolute",
                        left: "100%",
                        whiteSpace: "nowrap"
                    }}
                >
                    {animatedDots}
                </Typography>
            </Box>
        </Box>
    );
};

export default CustomAnimatedSpinner;
